import { useEffect, useState } from 'react'
import { ChevronDown } from 'lucide-react'
import React from 'react'

const LANGS = [
  { code: 'en', label: 'English' },
  { code: 'fi', label: 'Suomi' },
]

const getLanguage = (code) => {
  if (!code) {
    return LANGS[0]
  }
  const normalized = code.toLowerCase()
  return LANGS.find((lang) => lang.code === normalized) || LANGS[0]
}

export default function LanguageSelector({ value, onChange, className = '' }) {
  const [open, setOpen] = useState(false)
  const [current, setCurrent] = useState(() => getLanguage(value))

  useEffect(() => {
    setCurrent(getLanguage(value))
  }, [value])

  const handleSelect = (lang) => {
    setCurrent(lang)
    setOpen(false)
    onChange?.(lang.code)
  }

  return (
    <div className={`relative inline-block text-left ${className}`}>       
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center px-2 py-1 text-sm text-gray-100 hover:text-gray-300 focus:outline-none"
      >
        {current.code.toUpperCase()}
        <ChevronDown className="w-4 h-4 ml-1" />
      </button>

      {open && (
        <ul
          className="origin-top-left md:origin-top-right absolute top-full left-0 md:right-0 mt-2 w-28 bg-white text-gray-900 border border-gray-200 rounded shadow-lg z-50"
          onMouseLeave={() => setOpen(false)}
        >
          {LANGS.map((lang) => (
            <li key={lang.code}>
              <button
                onClick={() => handleSelect(lang)}
                className="block w-full text-left px-3 py-1 text-sm hover:bg-gray-100"
              >
                {lang.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
